import { ref } from 'vue'
const globalUploader = {
    enabled: ref(false),
    fileUploadDone: null,
    allFilesUploadDone: null,
}

export default globalUploader